import PropTypes from 'prop-types'

import React from 'react'
import {Form, Input, Textarea, Checkbox} from 'formsy-react-components'
import {Http, i18n} from 'common'

export class AdminForm extends React.Component {
    state = {
        initialObject: {},
        relatedObject: {},
        isBlank: true
    }

    static contextTypes = {
        router: PropTypes.object.isRequired,
        notificator: PropTypes.object.isRequired,
        config: PropTypes.object.isRequired
    }

    componentDidMount() {
        const {params} = this.props.match

        if (params.id == null && this.onCreateInitialObject != null) {
            this.onCreateInitialObject(this.state.initialObject)
        }


        this.fetchInitialObject(params)

        if (this.config.relation != null) {
            this.fetchRelatedObject(params)
        }
    }

    fetchInitialObject = (params) => {
        this.fetchObject(params, this.config.url, 'id', (data) => {
            if (this.onCompleteLoad) {
                this.onCompleteLoad(data)
            }

            this.setState({initialObject: data, isBlank: false})
        })
    }

    fetchRelatedObject = (params) => {
        const url = this.config.relation.url

        this.fetchObject(params, url, 'relationId', (data) => {
            this.setState({ relatedObject: data })
        })
    }

    fetchObject = (params, url, key, callback) => {
        const id = params[key]

        if (id != null) {
            Http.GET(`${url}${id}`, (data) => {
                callback(data)
            })
        }
    }


    onResetForm = () => {
        this.refs.form.reset()
    }

    onInvalid = (obj) => {
        const { notificator } = this.context
        notificator.message(i18n('form.failure-validate'), 'error')
    }

    onSubmit = (data) => {
        if (this.onBeforeSubmit != null) {
            this.onBeforeSubmit(data)
        }

        let {url} = this.config
        const {params} = this.props.match

        const {isBlank, initialObject} = this.state
        const method = isBlank ? 'post' : 'put'

        if (!isBlank) {
            url += `${initialObject.id}`
        }

        if (params.id != null) {
            data.id = params.id
        }

        Http.CALL(url, data, method, (data) => {
            const {config, router, notificator} = this.context
            let message = ''

            if (this.onAfterSubmit != null) {
                message = '.' + this.onAfterSubmit(data)
            }

            notificator.message(`${i18n('form.success')}${message}`, 'success')
            config.forceUpdate()

            this.setState({
                initialObject: data,
                isBlank: false
            })

            if (isBlank && data.id) {
                const {pathname} = this.props.location
                router.history.push(pathname.replace('new', data.id))
            }
        })
    }

    onCancel = () => {
        const {backUrl} = this.config
        const {router} = this.context
        router.history.push(backUrl)
    }
}
